<app-chart [title]="title" [tooltip]="tooltip">
  @if (chartDatasets && !noData) {
    <canvas
      class="content"
      baseChart
      [type]="'line'"
      [legend]="true"
      [datasets]="chartDatasets"
      [options]="chartOptions"
    ></canvas>
  } @else {
    <div class="no-data">
      <p>{{ 'common.noData' | labelsProvider }}</p>
    </div>
  }
</app-chart>
